import React from "react";
import { useTranslation } from "react-i18next";
import { FaEye } from "react-icons/fa6";
import Drawer from "react-modern-drawer";
import { useSelector } from "react-redux";

import { CONSTANTS } from "@constants/index";
import { LOCK_STATUS } from "@constants/unitDetails";
import { OpeningHoursBlockPropType } from "@models/components/organisation.model";
import { applyLocalization } from "@services/common.service";
import { RootState } from "@store/index";

import Exceptions from "../Exceptions/Exceptions";
import OpeningHours from "../OpeningHours/OpeningHours";
import WarningMessageBox from "../WarningMessageBox/WarningMessageBox";

const OpeningHoursBlock: React.FC<OpeningHoursBlockPropType> = ({
  resourceInfo,
  terminology,
}) => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = React.useState(false);
  const { isAuthenticated } = useSelector((state: RootState) => state.local);
  const toggleDrawer = () => {
    setIsOpen(prevState => !prevState);
  };
  return (
    <>
      {resourceInfo?.info?.lockStatus === LOCK_STATUS.CLOSE && (
        <WarningMessageBox
          message={t("warningMessage", {
            location: applyLocalization(
              terminology,
              CONSTANTS.TERMINOLOGY.LOCATION,
              t
            ),
          })}
        />
      )}

      {(resourceInfo?.openingHours?.length > 0 ||
        resourceInfo?.exceptions?.dates.length > 0) && (
        <div className="fg-open-hour-listing" data-testid="openingHours-block">
          {resourceInfo?.openingHours?.length > 0 && (
            <>
              <h5>{t("openingHoursHeading")}</h5>
              <OpeningHours openingHoursData={resourceInfo?.openingHours} />
            </>
          )}

          {isAuthenticated && resourceInfo?.exceptions?.dates.length !== 0 && (
            <button
              onClick={toggleDrawer}
              className="btn fg-btn fg-btn-filled-darkblue mb-0"
            >
              <FaEye /> {t("specialOpeningHoursTitle")}
            </button>
          )}
          <Drawer
            open={isOpen}
            onClose={toggleDrawer}
            direction="bottom"
            size="auto"
            style={{
              maxHeight: "50vh", // limit height
              paddingBottom: "2rem", // enable vertical scroll
            }}
          >
            <div className="container mt-4">
              <h4>{t("specialOpeningHoursTitle")}</h4>

              <Exceptions exceptions={resourceInfo?.exceptions} />
            </div>
          </Drawer>
        </div>
      )}
    </>
  );
};

export default OpeningHoursBlock;
